module.exports = __webpack_public_path__ + "img/enhancement-request.ca56a5c8.png";